import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useParams, Link, useNavigate } from "react-router-dom";
import { ChangePrevSearchHistory } from '../../../../redux/actions/partials/header/headerDesktop';
import { handleChangeDataPageSearch } from '../../../../redux/actions/pages/search';
import apiRequest from '../../../../utils/apiRequest';
import { IMAGE_ADDRESS, SEARCH_GET } from '../../../../apis';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Sheet } from 'react-modal-sheet';
import { handleChangeDataBottomSheetProducts } from '../../../../redux/actions/pages/category/productsMobile';
import { handleChangeDataPageCategoryProducts } from '../../../../redux/actions/pages/category/categoryProducts';
import { handleChangeDataHeaderDesktop } from '../../../../redux/actions/partials/header/headerDesktop';
import { handleChangeDataHeaderMobile } from '../../../../redux/actions/partials/header/headerMobile';

const SearchMobile = () => {
 	
 	const dispatch = useDispatch();
 	const navigate = useNavigate();

 	const [ params ] = useSearchParams();
 	const query = params.get("q")?.trim() || "";

 	const { catUrl } = useParams();

 	const { isBackdropLoading } = useSelector(state => state.allLoaders);
 	const { searchTxt, prevSearchHistory } = useSelector(state => state.headerDesktop);
 	const { products, productCount, filters } = useSelector(state => state.searchProducts);

 	const { isSheetOpen, filterIndex, filter } = useSelector(state => state.productsMobile);
 	const isSelectChild = filter?.options?.find(f => f.isSelect);

 	useEffect(() => {
 		if (!query) return;

	    // حذف تکراری‌ها
	    const filtered = prevSearchHistory.filter((item: string) => item !== query);

	    // اضافه کردن مورد جدید در ابتدای لیست
	    const newHistory = [query, ...filtered];

	    // محدود کردن به 5 آیتم
	    const limitedHistory = newHistory.slice(0, 5);

	    dispatch( ChangePrevSearchHistory(limitedHistory) );


	    apiSeach();

    }, [query]);



 	const searchUrl = (catUrl !== null && catUrl !== undefined) ? `${SEARCH_GET}/${catUrl}/?q=${encodeURIComponent(query)}` : `${SEARCH_GET}?q=${encodeURIComponent(query)}`;
    const apiSeach = (getParams = "") => {
    	if(! isBackdropLoading)
	    	apiRequest({
	            dispatch,
	            endpoint: searchUrl,
	            method: 'get',
	            token: null,
	            onSuccess: (res) => {
	            	dispatch(handleChangeDataPageSearch('products', res.products));
			    	dispatch(handleChangeDataPageSearch('productCount', res.productCount));
			    	if(getParams === "")
			    		dispatch(handleChangeDataPageSearch('filters', res.filters));
	            },
	            onError: (err) => {
	                console.error(err);
	            }
	        });
    };


    const handleToggleFilterOptions = (index) => {
		let newFilters = [...filters];
		newFilters.map((newFilter, newFilterIndex) => {
			newFilter.showOptions = (index === newFilterIndex && !newFilter.showOptions);
		});
		dispatch(handleChangeDataPageSearch('filters', newFilters));
	};

	const handleToggleOptionItemSelect = (optionIndex, filterIndex) => {
		let newFilters = [...filters];
		let isSelect = newFilters[filterIndex].options[optionIndex].isSelect;
		newFilters[filterIndex].options[optionIndex].isSelect = !isSelect;
		dispatch(handleChangeDataPageSearch('filters', newFilters));



		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}` : '';

		apiSeach(queryString);
	};


	const clearFilter = (event) => {
		event.preventDefault();

		let newFilters = filters;
		newFilters[filterIndex].options.map((option, optionIndex) => {
			option.isSelect = false;
		});
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));

		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}` : '';

		apiSeach(queryString);
	};

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


	const handleFilterClick = (index) => {
		dispatch(handleChangeDataBottomSheetProducts('filterIndex', index));
		dispatch(handleChangeDataBottomSheetProducts('filter', filters[index]));
		dispatch(handleChangeDataBottomSheetProducts('isSheetOpen', true));
	};

	const closeBottomSheet = () => {
		dispatch(handleChangeDataBottomSheetProducts('isSheetOpen', false));
	};

	const handleRemoveSearchTxt = () => {
		dispatch( handleChangeDataHeaderDesktop('searchTxt', '') );
        dispatch( handleChangeDataHeaderDesktop('searchResultWithCats', []) );
        dispatch( handleChangeDataHeaderDesktop('searchResultWithoutCats', []) );


		dispatch(handleChangeDataHeaderMobile('isSheetSearchOpen', true));
	};



    return (

    	<div className="flex flex-col grow">

			<div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" id="base_layout_mobile_sticky_header" style={{top: '0px'}}>
				<div>
					<header className="px-4 lg:py-2 py-3 relative flex items-start z-5 bg-neutral-000 shadow-none shadow-1-bottom">
						<div className="relative ml-0 w-full">
							<div className="w-full">
								<div>
									<div className="flex justify-between items-center">
										<div className="flex-1 BaseLayoutSearch_BaseLayoutSearch__QHPTB">
											<div data-cro-id="searchbox-click" className="flex items-center SearchInput_SearchInput__HB9qi SearchInput_SearchInput__searchInput__CEpaj ellipsis rounded-md bg-neutral-100 h-10 border-none bg-neutral-100 grow px-0 lg:px-4 text-body-2">
												<div className="w-full lg:rounded-full rounded-md">
													<div className="flex items-center justify-between grow min-w-0 h-9 px-3">
														<div className="flex cursor-pointer" onClick={() => navigate(-1)}>
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-neutral-500)'}}>
																<use xlinkHref="#arrowRight" />
															</svg>
														</div>
														<span data-cro-id="searchbox-type" className="grow h-10 ellipsis">
															<div className="lg:text-body-2 text-button-1 flex items-center h-full text-body-2 text-neutral-800 px-3">{searchTxt}
															</div>
															<div className="absolute top-2 right-13 flex" />
														</span>
														<div className="flex cursor-pointer" onClick={handleRemoveSearchTxt}>
															<div className="cube-font-icon" data-icon-name="cube-nav-close" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-neutral-500)'}} />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o !right-6 !top-[-2px] styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate(342px, 52px)'}}>
									<div className="flex items-center">
										<span>ویژگی‌های محصولت رو توصیف کن، مثل رنگ و جنس تا پیداش کنیم.
										</span>
										<div className="flex cursor-pointer">
											<div className="cube-font-icon" data-icon-name="cube-nav-close" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-white)'}} />
										</div>
									</div>
									<div />
								</div>
							</div>
						</div>
					</header>
				</div>
			</div>


			<div className="grow flex flex-col" style={{paddingBottom: '55px', paddingTop: '0px'}}>
				<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
					<div id="base_layout_mobile_static_header">
						<div>
						</div>
					</div>
				</div>
				<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX px-5 lg:px-0">
					<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
					</div>
					
					<div id="ProductListPagesWrapper" className="relative w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-between product-list_ProductList__wrapper__Evjm8">
						<section className="w-full grow relative">
							<div className="lg:static sticky lg:top-14 top-16 bg-neutral-000 z-2 top-14">
								<div>
									<div className="flex items-center overflow-scroll pl-3 hide-scrollbar overscroll-none flex items-center -mx-5 pr-3 pb-2 lg:pt-3 pt-1 gap-1 bg-neutral-000 lg:static hide-scrollbar overscroll-none">
										<div className="flex flex-row items-center gap-x-4">
											<div className="relative">
												<div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 flex-row-reverse py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer whitespace-nowrap lg:my-2 inline-block py-1 px-3 shadow-none" data-cro-id="plp-sort-icon">
													<span>پربازدیدترین
													</span>
													<div className="flex cursor-pointer ml-1">
														<svg style={{width: '15px', height: '15px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#sort"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										{/*<div className="relative">
											<div className="relative">
												<div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 flex-row-reverse py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer lg:my-2 inline-block py-1 px-3 shadow-none" data-cro-id="plp-filter-icon">
													<span>فیلتر
													</span>
													<div className="flex cursor-pointer ml-1">
														<svg style={{width: '15px', height: '15px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#filter"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>*/}
										<div className="flex items-center gap-1">
											{ 
												filters.map((filter, key) => {
													const isSelectChild = filter.options.find(f => f.isSelect);
													return (
														<div key={`filter-${key}`} className="relative">
															<div onClick={() => handleFilterClick(key)} className={`flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 ${isSelectChild ? 'styles_Chip--active-borderless__rAELA text-body-1' : 'text-body1-strong'} py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer lg:my-2 inline-block py-1 px-3 shadow-none truncate`}>
																<span>{filter.title}
																</span>
																{ filter.type !== 'switch' &&
																<div className="flex cursor-pointer mr-1">
																	<svg style={{width: '15px', height: '15px', fill: `${isSelectChild ? 'var(--color-icon-primary)' : 'var(--color-icon-high-emphasis)'}`}}>
																		<use xlinkHref="#chevronDown"></use>
																	</svg>
																</div>
																}
															</div>
														</div>
													);
												})
											}
										</div>
									</div>
								</div>
							</div>
							<div className="flex items-center justify-between pt-3 text-neutral-500">
								<span className="grow text-body1-strong">همه کالاها
								</span>
								<div className="mr-auto block lg:hidden xl:block">
									<span className="whitespace-nowrap text-body-2 ellispis-1 flex items-center gap-2">{toPersianDigits(productCount)} کالا
									</span>
								</div>
							</div>
							<div className="product-list_ProductList__pagesContainer__zAhrX product-list_ProductList__pagesContainer--withoutSidebar__aty9j">
								{ 
									products.map((product, key) => (
										<div className="product-list_ProductList__item__LiiNI" data-product-index={`${key + 1}`}>
											<Link to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow flex flex-col items-stretch justify-start py-2" >
												<div data-testid="product-card">
													<article className="overflow-hidden flex flex-col items-stretch justify-start">
														<div className="flex items-center justify-start mb-1">
															<div className="text-body2-extra grow">
																<br />
															</div>
														</div>
														<div className="flex grow relative flex-row">
															<div className="ml-3 flex flex-col items-center">
																<div className="flex items-stretch flex-col relative">
																	<div className="flex flex-col">
																		<div>
																			<div style={{width: '118px', height: '118px', lineHeight: '0'}}>
																				<picture>
																					<LazyLoadImage src={IMAGE_ADDRESS + product.image} className="w-full rounded-medium inline-block" width="118" height="118" alt={product.title} title="" style={{objectFit: 'contain'}} />
																				</picture>
																			</div>
																		</div>
																		{product.colors &&
																			<div className="flex items-center justify-center gap-2 mt-3">
																				{
																					product.colors.split(",").map((color, colorIndex) => (
																						<span className="rounded-circle inline-block color_Color__l0PYL border-complete-200" style={{backgroundColor: `#${color}`, width: '8px', height: '8px'}}>
																						</span>
																					))
																				}
																			</div>
																		}
																	</div>
																</div>
															</div>
															<div className="grow flex flex-col items-stretch justify-start">
																<div className="flex items-center justify-start gap-1 flex-wrap mb-1">
																	<br />
																	<br />
																</div>
																<div>
																	<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_HorizontalProductCard__productTitle__hzx5X">
																		{product.title}
																	</h3>
																</div>
																<div className="mb-1 flex items-center justify-between">
																	<div className="flex items-center" data-ab-id="">
																		{/*<p className="text-caption text-primary-700">تنها ۲ عدد در انبار باقی مانده
																		</p>*/}
																		<br />
																	</div>
																	<div className="flex items-center">
																		{/*<p className="text-body2-strong text-neutral-700">۴.۴
																		</p>
																		<div className="flex mr-2 shrink-0">
																			<svg style="width: 16px; height: 16px; fill: var(--color-icon-rating-0-2);">
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>*/}
																	</div>
																</div>
																<div className="pt-1 flex flex-col items-stretch justify-between">
																	<div className="flex items-center justify-between">
																		{ product.discount &&
																		<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																			<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪
																			</span>
																		</div>
																		}
																		<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
																			<span data-testid="price-final">{product.price ? toPersianDigits(product.price) : 'ناموجود'}
																			</span>
																			<div className="flex">
																				<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																					<use xlinkHref="#toman"></use>
																				</svg>
																			</div>
																		</div>
																	</div>
																	<div className="flex items-center justify-between pl-5">
																		{ product.oldPrice &&
																			<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">
																				{toPersianDigits(product.oldPrice)}
																			</div>
																		}
																	</div>
																</div>
															</div>
														</div>
													</article>
												</div>
											</Link>
										</div>
									))
								}
							</div>
						</section>
					</div>
				</div>
			</div>


			{ isSheetOpen && (
                <div
                    onClick={() => closeBottomSheet()}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 3,
                    }}
                />
            ) }

			<Sheet style={{zIndex: "4"}} isOpen={isSheetOpen} onClose={closeBottomSheet} detent="content-height" >
                <Sheet.Container >
                    <Sheet.Header className="">
                    	<div class="flex items-center px-5">
							<div class="break-words py-3 grow">
								<div class="flex items-center grow">
									<p class="grow text-h5 text-neutral-900">
										<span class="relative">{filter.title ?? ''}</span>
									</p>
								</div>
							</div>
							<div class="grow text-h5">
							</div>
							<div class="flex cursor-pointer">
								<svg onClick={closeBottomSheet} style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
                    </Sheet.Header>
                    <Sheet.Content>

                        <div class="grow flex flex-col overflow-y-auto">
							<div class="grow flex flex-col styles_children__hHq5Q py-4 px-5">
								<div>
									{
										filter?.options?.map((option, optionIndex) => (
											<div key={`filter-option-${optionIndex}`} class="w-full">
												<div class="w-full flex items-center justify-start">
													<div>
														<label class="flex items-center cursor-pointer styles_Checkbox__checkboxContainer__7joRB py-1 ml-4">
															<input class="invisible absolute" type="checkbox" id={`filter-option-${optionIndex}`} checked={option.isSelect} onChange={(e) => {e.stopPropagation(); handleToggleOptionItemSelect(optionIndex)}} />
															<span class="inline-flex justify-center items-center cursor-pointer rounded-small shrink-0 styles_Checkbox__checkbox__z1B5a styles_Checkbox__checkbox--secondary__FspFz">
																<div class="flex styles_Checkbox__icon__AaKB1">
																	<svg style={{width: '10px', height: '10px', fill: 'var(--color-icon-white)'}}>
																		<use xlinkHref="#check"></use>
																	</svg>
																</div>
															</span>
														</label>
													</div>
													<div class="grow text-neutral-700">
														<label for="17" class="w-full flex items-center justify-between py-3 lg:pl-3 border-complete-b">
															<div class="text-subtitle-strong">{option.title}
															</div>
														</label>
													</div>
													<div>
													</div>
												</div>
											</div>
										))
									}
								</div>
							</div>
						</div>

						<div class="w-full z-1 bg-neutral-000 px-5 py-4 shadow-1-top" >
							<div class="flex items-center justify-between gap-2.5">
								<button class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium flex-auto">
									<div class="flex items-center justify-center relative grow">مشاهده {toPersianDigits(productCount)} محصول
									</div>
								</button>
								<button onClick={clearFilter} disabled={!isSelectChild} class={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--outlined__saFC3 styles_btn--primary__y0GEv ${!isSelectChild ? 'styles_btn--disabled__lljQT' : ''} rounded-medium flex-auto`}>
									<div class="flex items-center justify-center relative grow">حذف فیلتر
									</div>
								</button>
							</div>
						</div>

                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>
    	
		</div>

    );
}

export default SearchMobile;